import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

// Types
import { IState } from "@/store";
import { ILanguage } from "@/models/constants";

@Component({
  computed: {
    ...mapState({
      languages: (state: IState) => state.constants.languages
    })
  }
})
export default class LanguagesStore extends Vue {
  public languages!: ILanguage[];
  public languagesLoaded = false;

  public async created() {
    await this.getLanguages();
    this.languagesLoaded = true;
  }

  public getLanguages() {
    return this.$store.dispatch("constants/getLanguages");
  }
}
